import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import LoginPage from './login/LoginPage'
import LogoutPage from './login/LogoutPage'

/*import Sifrant from './components/Sifrant'
import PravicePridelava from './components/PravicePridelava'
import PravicePredelava from './components/PravicePredelava'
import Pridelava from './components/Pridelava'
import Gerk from './components/Gerk'
import GerkPrint from './components/GerkPrint'

import DodajPridelovalca from './components/DodajPridelovalca'
import DodajKulture from './components/DodajKulture'
import DodajZivali from './components/DodajZivali'
import DodajProizvode from './components/DodajProizvode'


import DodajCertifikate from './components/DodajCertifikate'

import VsiGerki from './components/VsiGerki'
import Kulture from './components/Kulture'
import Zivali from './components/Zivali'
import Proizvodi from './components/Proizvodi'
import Kontrole from './components/Kontrole'
import Odlocbe from './components/Odlocbe'
import Certifikati from './components/Certifikati'
import Pridelovalec from './components/Pridelovalec'

import Predelava from './components/Predelava'
import KontrolePredelava from './components/KontrolePredelava'
import Dejavnosti from './components/Dejavnosti'
import CertifikatiPredelava from './components/CertifikatiPredelava'
import DislociraneEnote from './components/DislociraneEnote'

import DodajPredelovalca from './components/DodajPredelovalca'
import Predelovalec from './components/Predelovalec'
import DodajDejavnosti from './components/DodajDejavnosti'
import DodajDislociraneEnote from './components/DodajDislociranoEnoto'

import DodajKontrolePredelava from './components/DodajKontrolePredelava'
import DodajCertifikatPredelava  from './components/DodajCertifikatePredelava'


import CertifikatiJavno  from './components/CertifikatiJavno'
import CertifikatJavno  from './components/CertifikatJavno'
*/

import Stranke from './components/Stranke'
import Shema from './components/Shema'
import DodajStranko from './components/DodajStranko'
import IzdelajObrazec from './components/IzdelajObrazec'

import PosiljanjeObrazcev from './components/PosiljanjeObrazcev'

import PrikaziObrazec from './components/PrikaziObrazec'
import DodajObrazec from './components/DodajObrazec'
import {store} from './store/index.js'
import App from './App'

//import DodajPridelovalca from './components/DodajPridelovalca'
import DodajKulture from './components/DodajKulture'
import DodajZivali from './components/DodajZivali'
import DodajProizvode from './components/DodajProizvode'
import DodajProizvodePridelava from './components/DodajProizvodePridelava'
import DodajCertifikate from './components/DodajCertifikate'
import DodajCertifikateIP from './components/DodajCertifikateIP'
import DodajKontrole from './components/DodajKontrole'
import DodajKontroleIP from './components/DodajKontroleIP'
import DodajKontroloEko from './components/DodajKontroloEko'
import PripravaKontroleIP from './components/PripravaKontroleIP'
import DodeliKontroleIP from './components/DodeliKontroleIP'
import NadaljnjiUkrepiIP from './components/NadaljnjiUkrepiIP'
import NeskladjaIP from './components/NeskladjaIP'
import Neskladja from './components/Neskladja'
import DodajKontrolniListIP from './components/DodajKontrolniListIP'
import DodajKontrolniListEko from './components/DodajKontrolniListEko'

//import Pridelovalec from './components/Pridelovalec'
const Pridelovalec  =() => import('./components/Pridelovalec') 
const PrenesiDatoteko  =() => import('./components/PrenesiDatoteko') 
const PrenesiNalozenoDatoteko  =() => import('./components/PrenesiNalozenoDatoteko') 
import IP from './components/IP'
import IPPrijava from './components/IPPrijava'
import Predelovalec from './components/Predelovalec' 
//import CertifikatJavno  from './components/CertifikatJavno'
//import CertifikatJavnoPDF  from './components/CertifikatJavnoPDF'

//import PrijavniObrazecPDF  from './components/PrijavniObrazecPDF'
const CertifikatJavnoPDF  =() => import('./components/CertifikatJavnoPDF') 
const CertifikatJavnoPDFIP  =() => import('./components/CertifikatJavnoPDFIP') 
const CertifikatPorociloJavnoPDFIP  =() => import('./components/CertifikatPorociloJavnoPDFIP') 
const PrijavniObrazecPDF  =() => import('./components/PrijavniObrazecPDF') 
const CertificiranjePDF  =() => import('./components/CertificiranjePDF') 
const CertificiranPridelekPoCertifikatuPDF  =() => import('./components/CertificiranPridelekPoCertifikatuPDF') 
const ZapisnikIPPDF  =() => import('./components/ZapisnikIPPDF') 
const ZapisnikEkoPDF  =() => import('./components/ZapisnikEkoPDF') 

import NeskladjaIPVsa from './components/NeskladjaIPVsa'
import Zivali from './components/Zivali'
import DodajOdlocbe from './components/DodajOdlocbe'
//import CertifikatJavnoPDF2  from './components/CertifikatJavnoPDF2'
//import CertifikatJavnoPDFAng  from './components/CertifikatJavnoPDFAng'
import Certifikati from './components/Certifikati'
import Kontrole from './components/Kontrole'
import Gerk from './components/Gerk'
import GerkIP from './components/GerkIP'
//import GerkPrint from './components/GerkPrint'
const GerkPrint = () => import ('./components/GerkPrint')
const GerkPrintIP = () => import ('./components/GerkPrintIP')

const PrijavniObrazecEKO  =() => import('./components/PrijavniObrazecEKO') 
const PrijavniObrazecIP  =() => import('./components/PrijavniObrazecIP') 
const PrijavniObrazecIPPregled  =() => import('./components/PrijavniObrazecIPPregled') 
const PrijavniObrazecEkoPregled  =() => import('./components/PrijavniObrazecEKOPregled') 

Vue.use(Router)

//export default 
 export const router =  new Router({
  mode: 'history',

  routes: [

  /*  {
      path: '/javno/certifikat/:pridelovalecid',
      name: 'certifikatJavno',
      component: CertifikatJavno,
      props: true
    },
    */
    {
      path: '/gerk/print/:sezona/:pridelovalecid',
      name: 'gerkprint',
      component: GerkPrint,
      props: true
    },
    {
      path: '/gerkip/print/:sezona/:pridelovalecid/:kontrolaid',
      name: 'gerkprintip',
      component: GerkPrintIP,
      props: true
    },
   {
      path: '/javno/certifikatpdf/:certifikatid',
      name: 'certifikatJavnoPDF',
      component: CertifikatJavnoPDF,
      props: true
    },
    {
      path: '/javno/certifikatpdfip/:certifikatid',
      name: 'certifikatJavnoPDFIP',
      component: CertifikatJavnoPDFIP,
      props: true
    },
    {
      path: '/javno/certifikatporocilopdfip/:certifikatid',
      name: 'certifikatPorociloJavnoPDFIP',
      component: CertifikatPorociloJavnoPDFIP,
      props: true
    },
   
    {
      path: '/javno/obrazci/obnovaprijave/:pridelovalecid',
      name: 'prijavniObrazecPDF',
      component: PrijavniObrazecPDF,
      props: true
    },
    {
      path: '/javno/obrazci/certificiranje/:shema/:sezona/:pridelovalecid',
      name: 'certificiranjePDF',
      component: CertificiranjePDF,
      props: true
    },
    {
      path: '/javno/obrazci/certificiranpridelek/:shema/:sezona/:pridelovalecid',
      name: 'certificiranpridelekPDF',
      component: CertificiranPridelekPoCertifikatuPDF,
      props: true
    },
    
    {
      path: '/EKO PRI/zapisnik/:shema/:sezona/:pridelovalecid/:kontrolaid',
      name: 'zapisnikeko',
      component: ZapisnikEkoPDF,
      props: true
    },
    {
      path: '/:shema/prenesi/kontrolniobrazec/:sezona/:pridelovalecid/:kontrolaid',
      name: 'prenesiobrazecip',
      component: PrenesiDatoteko,
      props: true
    },
    {
      path: '/prenesi/datoteka/:datotekaid',
      name: 'prenesidatoteko',
      component: PrenesiNalozenoDatoteko,
      props: true
    },
  /*   {
      path: '/javno/certifikatpdf2/:pridelovalecid',
      name: 'certifikatJavnoPDF2',
      component: CertifikatJavnoPDF2,
      props: true
    },*//*
    {
      path: '/javno/certifikatpdfang/:pridelovalecid',
      name: 'certifikatJavnoPDFAng',
      component: CertifikatJavnoPDFAng,
      props: true
    },*/
    {
      path: '/',
      name: 'app',
      component: App,
      children: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage
    },
    {
      path: '/stranke',
      name: 'stranke',
      component: Stranke,
      meta: {
                requiredRoles: ["KO"] 
      }
    },
    {
      path: '/uporabniki/obrazci/obnovaprijave/ekopri/:sezona/:pridelovalecid',
      name: 'prijavniObrazecEKO',
      component: PrijavniObrazecEKO,
      props: true
    },
    {
      path: '/uporabniki/obrazci/pregledobnoveprijave/ip/:sezona/:pridelovalecid',
      name: 'prijavniObrazecIPPregled',
      component: PrijavniObrazecIPPregled,
      props: true
    },
    {
      path: '/uporabniki/obrazci/pregledobnoveprijave/ekopri/:sezona/:pridelovalecid',
      name: 'prijavniObrazecEkoPregled',
      component: PrijavniObrazecEkoPregled,
      props: true
    },
    {
      path: '/uporabniki/obrazci/obnovaprijave/ip/:sezona/:pridelovalecid',
      name: 'prijavniObrazecIP',
      component: PrijavniObrazecIP,
      props: true
    },

     {
      path: '/obrazci/posiljanje/:shema/:sezona',
      name: 'posiljanjeobrazcev',
      component: PosiljanjeObrazcev,
      meta: {
                requiredRoles: ["KO"] 
      },
      props: true
    },
    {
      path: '/dodajStranko',
      name: 'dodajStranko',
      component: DodajStranko,
      meta: {
                requiredRoles: ["KO"] 
      },
      props: true
    },
    {
      path: '/sheme',
      name: 'sheme',
      component: Home,
      meta: {
                requiredRoles: ["KO"] 
      },
      props: true
    },
    {
      path: '/certifikati',
      name: 'certifikatiplh',
      component: Home,
      meta: {
                requiredRoles: ["KO"] 
      },
      props: true
    },
      {
      path: '/kontrole/',
      name: 'kontrole',
      component: Home,
      meta: {
                requiredRoles: ["KO"] 
      },
      props: true
    },
    ,
      {
      path: '/neskladja/',
      name: 'neskladja',
      component: Home,
      meta: {
                requiredRoles: ["KO"] 
      },
      props: true
    },
    {
      path: '/kontrole/:shema/',
      name: 'kontrole',
      component: Kontrole,
      meta: {
                requiredRoles: ["KO"] 
      },
      props: true
    },
    
    {
      path: '/neskladja/IP/',
      name: 'neskladjaIPVsa',
      component: NeskladjaIPVsa,
      meta: {
                requiredRoles: ["KO"] 
      },
      props: true
    },
    {
      path: '/sheme/:shema',
      name: 'sheme',
      component: Shema,
      meta: {
                requiredRoles: ["KO"] 
      },
      props: true
    },
    {
      path: '/dodajShemo',
      name: 'dodajShemo',
      component: Home,
      meta: {
                requiredRoles: ["KO"] 
      },
      props: true
    },
    {
      path: '/uporabniki',
      name: 'uporabniki',
      component: Home,
      meta: {
                requiredRoles: ["KO"] 
      },
      props: true
    },
     {
      path: '/certifikati/:shema/:sezona',
      name: 'certifikati',
      component: Certifikati,
      meta: {
                requiredRoles: ["KO"] 
      },
      props: true
    },
    {
      path: '/zivali/:sezona',
      name: 'zivali',
      component: Zivali,
      meta: {
                requiredRoles: ["KO"] 
      },
      props: true
    },
    {
      path: '/predloge',
      name: 'predloge',
      component: Home,
      meta: {
                requiredRoles: ["KO"] 
      },
      props: true
    },
    {
      path: '/obrazci',
      name: 'obrazci',
      component: DodajObrazec,
      meta: {
                requiredRoles: ["KO"] 
      },
      props: true
    },
    {
      path: '/izdelajobrazec',
      name: 'izdelajobrazec',
      component: IzdelajObrazec,
      meta: {
                requiredRoles: ["KO"] 
      },
      props: true
    },
    {
      path: '/prikaziobrazec',
      name: 'prikaziobrazec',
      component: PrikaziObrazec,
      meta: {
                requiredRoles: ["KO"] 
      },
      props: true
    },
     {
      path: 'pridelava/kultura/:sezona/:pridelovalecid',
      name: 'kultura',
      component: DodajKulture,
      props: true
    },
     {
      path: 'pridelava/zival/:sezona/:pridelovalecid',
      name: 'zival',
      component: DodajZivali,
      props: true
    },
     {
      path: 'pridelava/proizvod/:sezona/:pridelovalecid',
      name: 'proizvodpridelava',
      component: DodajProizvodePridelava,
      props: true
    },
     {
      path: 'predelava/proizvod/:sezona/:pridelovalecid',
      name: 'proizvod',
      component: DodajProizvode,
      props: true
    },
    {
      path: '/pridelava/odlocba/:sezona/:shema/:pridelovalecid',
      name: 'odlocba',
      component: DodajOdlocbe,
      props: true
    },
    {
      path: '/pridelava/certifikat/:sezona/:shema/:pridelovalecid',
      name: 'certifikat',
      component: DodajCertifikate,
      props: true
    },
    {
      path: '/certifikat/:sezona/:shema/:pridelovalecid/:kontrolaid',
      name: 'certifikatip',
      component: DodajCertifikateIP,
      props: true
    },
    {
      path: '/pridelava/kontrola/:shema/:sezona/:pridelovalecid',
      name: 'kontrola',
      component: DodajKontrole,
      props: true
    },
    {
      path: '/:shema/kontrole/:sezona/:pridelovalecid',
      name: 'kontroleip',
      component: DodajKontroleIP,
      props: true
    },
    {
      path: '/:shema/dodelikontrole/:sezona/',
      name: 'dodelikontroleip',
      component: DodeliKontroleIP,
      props: true
    },
    {
      path: '/EKO PRI/kontrola/:shema/:sezona/:pridelovalecid/:kontrolaid',
      name: 'kontrolaeko',
      component: DodajKontroloEko,
      props: true
    },
    {
      path: '/:shema/priprava/kontrola/:sezona/:pridelovalecid/:kontrolaid',
      name: 'pripravakontroleip',
      component: PripravaKontroleIP,
      props: true
    },
    {
      path: '/:shema/dodajobrazec/kontrola/:sezona/:pridelovalecid/:kontrolaid',
      name: 'dodajobrazecip',
      component: DodajKontrolniListIP,
      props: true
    },
    {
      path: '/ekopri/dodajobrazec/kontrola/:sezona/:pridelovalecid/:kontrolaid',
      name: 'dodajobrazeceko',
      component: DodajKontrolniListEko,
      props: true
    },
    {
      path: '/:shema/kontrola/ukrep/:sezona/:pridelovalecid/:kontrolaid',
      name: 'kontrolaukrepip',
      component:NadaljnjiUkrepiIP,
      props: true
    },
    {
      path: '/:shema/kontrola/neskladja/:sezona/:pridelovalecid/:kontrolaid',
      name: 'neskladjaip',
      component:NeskladjaIP,
      props: true
    },
    
     {
      path: '/predelava/predelovalec/:sezona/:pridelovalecid',
      name: 'predelovalec',
      component: Predelovalec,
      props: true
    },
     {
      path: '/uredi/:shema/:sezona/:pridelovalecid',
      name: 'ip',
      component: IP,
      props: true
    },
    {
      path: '/prijava/:shema/:sezona/:pridelovalecid',
      name: 'ipprijava',
      component: IPPrijava,
      props: true
    },
    {
      path: '/pridelava/pridelovalec/:sezona/:pridelovalecid',
      name: 'pridelovalec',
      component: Pridelovalec,
      props: true
    },

 {
      path: '/pridelava/gerk/:sezona/:pridelovalecid',
      name: 'gerk',
      component: Gerk,
      props: true
    },
    {
      path: '/ip/gerk/:podshema/:sezona/:pridelovalecid/:kontrolaid',
      name: 'gerkip',
      component: GerkIP,
      props: true
    },
    /*,
      {
      path: '/javno/certifikat',
      name: 'certifikatJavno',
      component: CertifikatJavno,
      props: true
    },

    // loads Home component
    {
      path: '/',
      name: 'app',
      component: App,
      children: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage
    },
     {
      path: '/sifrant',
      name: 'sifrant',
      component: Sifrant,
      meta: {
                requiredRoles: ["MKGP"] 
      }
    },
      {
      path: '/pravicePridelava',
      name: 'pravicePridelava',
      component: PravicePridelava,
      meta: {
                requiredRoles: ["MKGP"] 
      }

    },
      {
      path: '/pravicePredelava',
      name: 'pravicePredelava',
      component: PravicePredelava,
      meta: {
                requiredRoles: ["MKGP"] 
      }
    },
    ,
    {
      path: '/pridelava/:sezona?',
      name: 'pridelava',
      component: Pridelava,
      props: true
    },
    
    {
      path: '/pridelava/dodajPridelovalca/:sezona/',
      name: 'dodajPridelovalca',
      component: DodajPridelovalca,
      props: true
    },
     {
      path: '/pridelava/pridelovalec/:sezona/:pridelovalecid',
      name: 'pridelovalec',
      component: Pridelovalec,
      props: true
    },
    {
      path: 'pridelava/kultura/:sezona/:pridelovalecid',
      name: 'kultura',
      component: DodajKulture,
      props: true
    },
     {
      path: 'pridelava/zival/:sezona/:pridelovalecid',
      name: 'zival',
      component: DodajZivali,
      props: true
    },
     {
      path: 'pridelava/proizvod/:sezona/:pridelovalecid',
      name: 'proizvod',
      component: DodajProizvode,
      props: true
    },
     {
      path: '/pridelava/kontrola/:sezona/:pridelovalecid',
      name: 'kontrola',
      component: DodajKontrole,
      props: true
    },
     {
      path: '/pridelava/odlocba/:sezona/:pridelovalecid',
      name: 'odlocba',
      component: DodajOdlocbe,
      props: true
    },
     {
      path: '/pridelava/certifikat/:sezona/:pridelovalecid',
      name: 'certifikat',
      component: DodajCertifikate,
      props: true
    },
      {
      path: '/vsiGerki/:sezona?',
      name: 'vsiGerki',
      component: VsiGerki,
      props: true
    },
    {
      path: '/kulture/:sezona?',
      name: 'kulture',
      component: Kulture,
      props: true
    },
    {
      path: '/zivali/:sezona?',
      name: 'zivali',
      component: Zivali,
      props: true
    },
     {
      path: '/proizvodi/:sezona?',
      name: 'proizvodi',
      component: Proizvodi,
      props: true
    },
     {
      path: '/kontrole',
      name: 'kontrole',
      component: Kontrole,
      props: true
    },
     {
      path: '/odlocbe/:sezona?',
      name: 'odlocbe',
      component: Odlocbe,
      props: true
    },
    {
      path: '/certifikati/:sezona?',
      name: 'certifikati',
      component: Certifikati,
      props: true
    },
//predelava routes
    {
      path: '/predelava/:sezona?',
      name: 'predelava',
      component: Predelava,
      props: true
    },
    {
      path: '/predelava/dodajPredelovalca/:sezona/',
      name: 'dodajPredelovalca',
      component: DodajPredelovalca,
      props: true
    },
    {
      path: '/predelava/predelovalec/:sezona/:predelovalecid',
      name: 'predelovalec',
      component: Predelovalec,
      props: true
    },
    {
      path: '/dislociraneEnote/:sezona?',
      name: 'dislociraneEnote',
      component: DislociraneEnote,
      props: true
    },
     {
      path: 'predelava/dislociraneEnote/:sezona/:predelovalecid',
      name: 'dislociranaEnota',
      component: DodajDislociraneEnote,
      props: true
    },
    {
      path: '/dejavnosti/:sezona?',
      name: 'dejavnosti',
      component: Dejavnosti,
      props: true
    },
     {
      path: 'predelava/dejavnost/:sezona/:predelovalecid',
      name: 'dejavnost',
      component: DodajDejavnosti,
      props: true
    },

     {
      path: '/kontrolePredelava/:sezona?',
      name: 'kontrolePredelava',
      component: KontrolePredelava,
      props: true
    },
     {
      path: '/predelava/kontrole/:sezona/:predelovalecid',
      name: 'kontrolaPredelava',
      component: DodajKontrolePredelava,
      props: true
    },
     
    {
      path: '/certifikatiPredelava/:sezona?',
      name: 'certifikatiPredelava',
      component: CertifikatiPredelava,
      props: true
    },
     {
      path: '/predelava/certifikati/:sezona/:predelovalecid',
      name: 'certifikatPredelava',
      component: DodajCertifikatPredelava,
      props: true
    },
     

     {
      path: '/javno/certifikati',
      name: 'certifikatiJavno',
      component: CertifikatiJavno,
      props: true
    },
   
   */
    {
       path: '/logout',
      name: 'logout',
      component: LogoutPage
    }
  ]
  },
  ]
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['login','app', 'home','/javno/certifikati','/javno/certifikat','/javno/certifikatpdf','certifikatJavnoPDF','prijavniObrazecPDF'];
  const authRequired = !publicPages.includes(to.name);
  const loggedIn = localStorage.getItem('user');
  //poglej kere sheme ima..
//nujno uredit
  //let role=store.userDetails.vloga;
  //console.log("VLOGA IZ ROUTER:");
  //const store = require('./store/index.js'); 
   //store.dispatch('alert/error', "Za obisk te strani morate biti prijavljeni!", { root: true });
  
  if (authRequired && !loggedIn) {
      store.dispatch('alert/error', "Za obisk te strani morate biti prijavljeni!", { root: true });
    return next('/login');
  }
  //if(to)

  next();
});


